<template>
    <div class="container">
        <div class="row justify-content-center">
            <div class="how-to-earn-points-container col-8 col-md-6" v-on:click="toggleShowHowToEarnPointsModal()">
        <span class="how-to-earn-points-text">HOW DO I EARN POINTS?
          <BIconChevronDown class="chev-down-white"/>
        </span>
            </div>
        </div>
        <HowToEarnPointsModal v-if="showHowToEarnPointsModal"></HowToEarnPointsModal>
        <div class="text-box">
            <p class="mb-0">Make your predictions by selecting a country by scrolling left or right to predict your
                gold, silver and bronze medal for each sport.</p>
        </div>
        <hr class="line-break">
        <p class="round-name-text"><b>{{selectedRound.RoundName}}</b></p>
        <div class="olympics-round-text-box">
            <p class="mb-0 olympics-round-text">{{getDayOfWeek(selectedRound.RoundStartDate)}}
                {{getDay(selectedRound.RoundEndDate)}} {{ getMonth(selectedRound.RoundStartDate) }} {{
                getYear(selectedRound.RoundStartDate)
                }}</p>
        </div>
        <div v-for="(fixture, fixtureIndex) in roundFixtures" :key="fixtureIndex">
            <div class="olympics-round-text-box">
                <p class="olympics-round-text">{{fixture.EventName}} | STARTS: {{ getTime(fixture.StartDate) }}</p>
            </div>
            <div class="container fixture-box">
                <div style="position: relative">
                    <img class="fixture-icon" :src="getfixtureIcon(fixture.DisciplineName)" alt="">
                </div>
                <h5 class="no-teams-text" v-if="fixture.hasNoTeams">Participants for this event will still be confirmed. Come back during the course of the day to predict these events!</h5>
                <Carousel3d v-if="fixture.MedalType === 1 && !fixture.hasNoTeams || fixture.MedalType === 0 && !fixture.hasNoTeams"
                            :width="80"
                            :height="80"
                            :space="80"
                            :controlsVisible=true
                            :display="3"
                            :startIndex="getSlideStartIndex(fixture, 'gold', fixtureIndex)"
                            @before-slide-change="beforeSlideChange(fixtureIndex)"
                            @after-slide-change="onAfterGoldSlideChange"
                >
                    <slide v-for="(participant, countryIndex) in fixture.participants"
                           :index="countryIndex"
                           :key="countryIndex"
                    >
                        <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                            <img
                                    :style="getMedalBackgroundColour('gold')"
                                    :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
                                    :src="getCountryFlag(participant.TeamName)"
                            >
                        </template>
                    </slide>
                </Carousel3d>
                <Carousel3d v-if="fixture.MedalType === 1 && !fixture.hasNoTeams  || fixture.MedalType === 0 && !fixture.hasNoTeams"
                            :width="80"
                            :height="80"
                            :space="80"
                            :controlsVisible=true
                            :display="3"
                            :startIndex="getSlideStartIndex(fixture, 'silver', fixtureIndex)"
                            @before-slide-change="beforeSlideChange(fixtureIndex)"
                            @after-slide-change="onAfterSilverSlideChange"
                >
                    <slide v-for="(participant, countryIndex) in fixture.participants"
                           :index="countryIndex"
                           :key="countryIndex"
                    >
                        <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                            <img
                                    :style="getMedalBackgroundColour('silver')"
                                    :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0)}"
                                    :src="getCountryFlag(participant.TeamName)"
                            >
                        </template>
                    </slide>
                </Carousel3d>
                <Carousel3d
                        v-if="fixture.MedalType === 2 && !fixture.hasNoTeams  || fixture.MedalType === 0 && !fixture.hasNoTeams"
                        :width="80"
                        :height="80"
                        :space="80"
                        :controlsVisible=true
                        :display="3"
                        :startIndex="getSlideStartIndex(fixture, 'bronze', fixtureIndex)"
                        @before-slide-change="beforeSlideChange(fixtureIndex)"
                        @after-slide-change="onAfterBronzeSlideChange"
                >
                    <slide v-for="(participant, countryIndex) in fixture.participants"
                           :index="countryIndex"
                           :key="countryIndex"
                    >
                        <template slot-scope="{ index, isCurrent, leftIndex, rightIndex }">
                            <img
                                    :style="getMedalBackgroundColour('bronze')"
                                    :class="{ current: isCurrent, onLeft: (leftIndex >= 0), onRight: (rightIndex >= 0) }"
                                    :src="getCountryFlag(participant.TeamName)"
                            >
                        </template>
                    </slide>
                </Carousel3d>
            </div>
        </div>
        <div class="submit-button-box col-12">
            <button class="submit-button" v-on:click="submitPredictions()"><p class="button-text">Submit
                predictions</p></button>
        </div>
    </div>
</template>

<script>
    import ScorePredictorService from "../../services/scorePredictorService";
    import moment from 'moment'
    import {mapMutations, mapState} from "vuex";
    import {sports} from "../../config/sports";
    import {BIconChevronDown} from 'bootstrap-vue';
    import HowToEarnPointsModal from "@/components/HowToEarnPointsModal";
    import {Carousel3d, Slide} from 'vue-carousel-3d'

    export default {
        name: "MakeOlympicsPredictions",
        components: {
            BIconChevronDown,
            HowToEarnPointsModal,
            Carousel3d,
            Slide,
        },
        data() {
            return {
                roundFixtures: [],
                medalIndex: undefined,
                fixtureIndex: undefined
            }
        },
        computed: mapState(['userData', 'selectedSport', 'selectedLeague', 'selectedRound', 'roundPredictions', 'showHowToEarnPointsModal']),
        methods: {
            ...mapMutations(['setPointsScoringBreakdown', 'toggleShowHowToEarnPointsModal', 'clearRoundPredictions', 'setRoundPredictions', 'setIsLoading']),

            getSlideStartIndex(fixture, medal, fixtureIndex) {
                if (this.roundPredictions.length > 0) {
                    const participatingCountries = [];
                    fixture.participants.forEach((country) => participatingCountries.push(country.TeamName));
                    if (medal === 'gold') return participatingCountries.indexOf(fixture.selectedMedalWinners[0].gold);
                    if (medal === 'silver') return participatingCountries.indexOf(fixture.selectedMedalWinners[1].silver);
                    if (medal === 'bronze') return participatingCountries.indexOf(fixture.selectedMedalWinners[2].bronze);
                }
            },
            beforeSlideChange(fixtureIndex) {
                this.fixtureIndex = fixtureIndex;
            },
            onAfterGoldSlideChange(index) {
                this.roundFixtures[this.fixtureIndex].selectedMedalWinners[0].gold = this.roundFixtures[this.fixtureIndex].participants[index].TeamName;
                console.log(this.roundFixtures[this.fixtureIndex].participants[index].TeamName)
            },
            onAfterSilverSlideChange(index) {
                this.roundFixtures[this.fixtureIndex].selectedMedalWinners[1].silver = this.roundFixtures[this.fixtureIndex].participants[index].TeamName;
                console.log(this.roundFixtures[this.fixtureIndex].participants[index].TeamName)
            },
            onAfterBronzeSlideChange(index) {
                this.roundFixtures[this.fixtureIndex].selectedMedalWinners[2].bronze = this.roundFixtures[this.fixtureIndex].participants[index].TeamName;
                console.log(this.roundFixtures[this.fixtureIndex].participants[index].TeamName)
            },
            getMedalBackgroundColour(medal) {
                if (medal === 'gold') return `background: linear-gradient(to right, #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C);`;
                if (medal === 'silver') return `background: linear-gradient(90deg, #7E7E7E 0%, #E3E3E3 25%, #787878 50%, #E3E3E3 75%, #7E7E7E 100%);`;
                if (medal === 'bronze') return `background: linear-gradient(90deg, #844414 0%, #FCD5BE 25%, #CF7D52 50%, #FCD5BE 75%, #844414 100%);`;
            },
            getCountryFlag(countryName) {
                const teamConfig = sports.get(this.selectedSport).get(this.selectedLeague).get(countryName);
                if (teamConfig) return require(`../../assets/${teamConfig.logo}`);
                else return require(`../../assets/leagues/Japan-2021.png`)
            },
            getfixtureIcon(name) {
                const assetName = name.replace(' ', '-');
                const removedSecondSpaces = assetName.replace(' ', '-');
                if (removedSecondSpaces === 'Baseball/Softball') return require(`../../assets/olympics/disciplines/Baseball.png`);
                return require(`../../assets/olympics/disciplines/${removedSecondSpaces}.png`)
            },
            async submitPredictions() {
                const fixture = {};
                await this.roundFixtures.asyncForEach(async (olympicEvent) => {
                    fixture.msisdn = this.userData.msisdn;
                    fixture.roundId = this.selectedRound.RoundID;
                    fixture.eventId = olympicEvent.EventId;
                    if (olympicEvent.hasNoTeams) {
                        fixture.gold = null;
                        fixture.silver = null;
                        fixture.bronze = null;
                    }
                    if (olympicEvent.MedalType === 1) {
                        if (olympicEvent.hasNoTeams) {
                            fixture.gold = null;
                            fixture.silver = null;
                            fixture.bronze = null;
                        } else {
                            fixture.gold = this.getTeamId(olympicEvent.selectedMedalWinners[0].gold);
                            fixture.silver = this.getTeamId(olympicEvent.selectedMedalWinners[1].silver);
                            fixture.bronze = null;
                        }
                    }
                    if (olympicEvent.MedalType === 2) {
                        if (olympicEvent.hasNoTeams) {
                            fixture.gold = null;
                            fixture.silver = null;
                            fixture.bronze = null;
                        } else {
                            fixture.gold = null;
                            fixture.silver = null;
                            fixture.bronze = this.getTeamId(olympicEvent.selectedMedalWinners[2].bronze);
                        }
                    }
                    if (olympicEvent.MedalType === 0) {
                        if (olympicEvent.hasNoTeams) {
                            fixture.gold = null;
                            fixture.silver = null;
                            fixture.bronze = null;
                        } else {
                            fixture.gold = this.getTeamId(olympicEvent.selectedMedalWinners[0].gold);
                            fixture.silver = this.getTeamId(olympicEvent.selectedMedalWinners[1].silver);
                            fixture.bronze = this.getTeamId(olympicEvent.selectedMedalWinners[2].bronze);
                        }
                    }
                    await ScorePredictorService.enterOlympicsRoundPredictions(fixture, this.userData.msisdn);
                });
                this.$router.push('view-predictions')
            },
            getTeamId(teamName) {
                return sports.get(this.selectedSport).get(this.selectedLeague).get(teamName).teamId;
            },
            formatDate(date) {
                return moment(date).format('LLLL')
            },
            addRoundPredictions(fixtures) {
                fixtures.forEach((fixture) => {
                    this.currentPredictions.push(fixture);
                    this.setRoundPredictions(fixture);
                });
            },

            addRoundFixtures(fixtures) {
                if (this.roundPredictions.length > 0) {
                    fixtures.forEach((fixture) => {
                            if (fixture.participants.length < 1) {
                                fixture.hasNoTeams = true;
                            } else {
                                if (fixture.MedalType === 1) {
                                    this.roundPredictions.forEach((prediction) => {
                                        if (prediction.EventName === fixture.EventName) {
                                            fixture.selectedMedalWinners[0].gold = prediction.Gold;
                                            fixture.selectedMedalWinners[1].silver = prediction.Silver;
                                        } else {
                                            fixture.selectedMedalWinners[0].gold = fixture.participants[0].TeamName;
                                            fixture.selectedMedalWinners[1].silver = fixture.participants[0].TeamName;
                                        }
                                    });
                                }
                                if (fixture.MedalType === 2) {
                                    this.roundPredictions.forEach((prediction) => {
                                        if (prediction.EventName === fixture.EventName) {
                                            fixture.selectedMedalWinners[2].bronze = prediction.Bronze;
                                        } else {
                                            fixture.selectedMedalWinners[2].bronze = fixture.participants[0].TeamName;
                                        }
                                    });
                                }
                                if (fixture.MedalType === 0) {
                                    this.roundPredictions.forEach((prediction) => {
                                        if (prediction.EventName === fixture.EventName) {
                                            fixture.selectedMedalWinners[0].gold = prediction.Gold;
                                            fixture.selectedMedalWinners[1].silver = prediction.Silver;
                                            fixture.selectedMedalWinners[2].bronze = prediction.Bronze;
                                        } else {
                                            fixture.selectedMedalWinners[0].gold = fixture.participants[0].TeamName;
                                            fixture.selectedMedalWinners[1].silver = fixture.participants[0].TeamName;
                                            fixture.selectedMedalWinners[2].bronze = fixture.participants[0].TeamName;
                                        }
                                    });
                                }
                            }
                        this.roundFixtures.push(fixture);
                    });
                } else {
                    fixtures.forEach((fixture) => {
                        if (fixture.participants.length < 1) {
                            fixture.hasNoTeams = true;
                        } else {
                            if (fixture.MedalType === 1) {
                                fixture.selectedMedalWinners[0].gold = fixture.participants[0].TeamName;
                                fixture.selectedMedalWinners[1].silver = fixture.participants[0].TeamName;
                            }
                            if (fixture.MedalType === 2) {
                                fixture.selectedMedalWinners[2].bronze = fixture.participants[0].TeamName;
                            }
                            if (fixture.MedalType === 0) {
                                fixture.selectedMedalWinners[0].gold = fixture.participants[0].TeamName;
                                fixture.selectedMedalWinners[1].silver = fixture.participants[0].TeamName;
                                fixture.selectedMedalWinners[2].bronze = fixture.participants[0].TeamName;
                            }
                        }
                        this.roundFixtures.push(fixture);
                    });
                }
            },
            async getRoundFixtures() {
                this.setIsLoading(true);
                const response = await ScorePredictorService.getRoundFixtures(this.selectedRound.RoundID, this.userData.msisdn);
                this.setIsLoading(false);
                response.fixtures.forEach((fixture) => {
                    fixture.hasNoTeams = false;
                    fixture.selectedMedalWinners = [
                        {gold: undefined},
                        {silver: undefined},
                        {bronze: undefined}
                    ]
                });
                this.addRoundFixtures(response.fixtures);
                this.setPointsScoringBreakdown(response.pointsScoringBreakdown);
            },
            clearState() {
                this.roundFixtures = [];
            },
            getDayOfWeek(date) {
                return moment(date).format('dddd')
            },
            getDay(date) {
                return moment(date).format('Do')
            },
            getMonth(date) {
                return moment(date).format('MMMM')
            },
            getYear(date) {
                return moment(date).format('YYYY')
            },
            getTime(date) {
                return moment(date).format('hh:mm a')
            },
        },
        beforeMount() {
            this.clearState();
            this.getRoundFixtures();
        }
    }
</script>

<style scoped lang="scss">
    .round-name-text {
        color: $round-details-text-color;
        font-size: x-large;
        font-weight: 500;
        margin-bottom: 0;
    }

    .no-teams-text {
        margin: 10px;
        color: $round-details-text-color;
    }

    .fixture-icon {
        left: -40px;
        top: -40px;
        position: absolute;
        width: 80px;
        height: 80px
    }

    .how-to-earn-points-text {
        color: $heading-text-color;
    }

    .text-box {
        display: flex;
        justify-content: center;
        align-content: center;
        margin: 1vw;
        padding: 1vw;
    }

    .carousel-3d-slide {
        border-radius: 5px;
    }

    img {
        padding: 15px;
    }

    ::v-deep .next {
        color: $header-bg-color;
    }

    ::v-deep .prev {
        color: $header-bg-color;
    }

    .carousel-3d-container {
        width: 90%;
    }

    .olympics-round-text {
        font-size: large;
        width: 70vw;
    }

    .olympics-round-text-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @media screen and (max-width: 900px) {
        .olympics-round-text {
            font-size: medium;
        }
    }

    .country-flags {
        height: 100px;
        width: 100px;
    }

    .fixture-box {
        display: flex;
        justify-content: center;
        height: auto;
        padding: 0;
        width: 80vw;
        background: #B1AEAC;
        flex-direction: column;
        border-radius: 5px;
        margin-bottom: 2vh;
    }

    @media screen and (min-width: 700px) {
        .fixture-box {
            width: 50vw
        }
    }

    img.onLeft {
        background-color: #E4E5E7 !important;
        background-image: none !important;
    }

    img.onRight {
        background-color: #E4E5E7 !important;
        background-image: none !important;
    }

    .country-carousel {
        display: flex;
        flex-direction: row;
    }

    .submit-button-box {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    .submit-button {
        height: 10vh;
        margin-top: 2vw;
        margin-bottom: 2vw;
        border-radius: 5px;
        background-color: $submit-button-red;
        width: 90%;
        border: none !important;
    }

    .date-time {
        display: flex;
        justify-content: center;
        align-items: center;
        margin-top: 2vh;
    }

    .description-text {
        z-index: 0;
        font-size: large;
    }

    .line-break {
        color: $line-break-color;
    }

    .date-text {
        font-size: large;
        margin: 0;
        padding: 0;
    }

    .predictions-closed-text {
        font-size: large;
        color: red;
        padding: 0;
        margin-bottom: 1vh;
    }

    .button-text {
        font-size: large;
        color: white;
        margin: 0;
    }

</style>
